import { render, staticRenderFns } from "./detection.vue?vue&type=template&id=5713860d&scoped=true&"
import script from "./detection.vue?vue&type=script&lang=js&"
export * from "./detection.vue?vue&type=script&lang=js&"
import style0 from "./detection.vue?vue&type=style&index=0&id=5713860d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5713860d",
  null
  
)

export default component.exports